export default "__VITE_ASSET__BZSrrvkQ__"